import React from 'react'
import { formatPhone } from '@@partner:helpers/util'
import { useGridHelper } from '@@partner:helpers/crud/grid'
import { useFetchAllOperators } from '@@partner:graphql/query/employees/allOperators.gql'

import { Link, generatePath } from 'react-router-dom'
import { Table, Tag, Pagination } from 'rsuite'
import AppLoader from '@components/common/AppLoader'
import CommonStatusLabel from '@components/common/CommonStatusLabel'
import { EditButton } from '@components/common/form/Buttons'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'

import { ROUTE_USERS_MANAGEMENT_EDIT } from '@@partner:config/routes'

const Column = Table.Column
const HeaderCell = Table.HeaderCell
const Cell = Table.Cell

export interface OperatorsTableProps {
  header?: string
}

export default function OperatorsTable ({ header }: OperatorsTableProps) {
  const { page, tableSort, handlePageSelect, handleSortColumn } =
    useGridHelper()

  const { data, loading, error } = useFetchAllOperators({
    pager: { page },
    sort: {
      direction: tableSort.direction,
      fieldName: tableSort.fieldName
    }
  })

  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        error={error}
        title="Ошибка загрузки операторов"
      />
    )
  }

  const operators = data?.operators?.edges ?? []
  const pageInfo = data?.operators?.pageInfo

  return (
    <>
      {header && <h4 className="u-form-heading">{header}</h4>}
      <Table
        data={operators}
        autoHeight
        sortColumn={tableSort.fieldName}
        sortType={tableSort.sortType}
        onSortColumn={handleSortColumn}
        wordWrap
        loading={loading}
        renderLoading={() =>
          loading ? <AppLoader.Inner content="Загрузка таблицы" /> : null
        }
        affixHeader
      >
        <Column sortable flexGrow={1} verticalAlign="middle">
          <HeaderCell>ИД</HeaderCell>
          <Cell dataKey="id" />
        </Column>

        <Column sortable flexGrow={2} verticalAlign="middle">
          <HeaderCell>ФИО</HeaderCell>
          <Cell dataKey="first_name">
            {(operator) => <span>{operator.fullName}</span>}
          </Cell>
        </Column>

        <Column sortable flexGrow={2} verticalAlign="middle">
          <HeaderCell>Телефон</HeaderCell>
          <Cell dataKey="phone">
            {(operator) => (
              <Tag color="blue">{formatPhone(operator.phone)}</Tag>
            )}
          </Cell>
        </Column>

        <Column sortable flexGrow={2} verticalAlign="middle">
          <HeaderCell>E-mail</HeaderCell>
          <Cell dataKey="email">
            {(operator) => <Tag color="blue">{operator.email}</Tag>}
          </Cell>
        </Column>

        <Column sortable flexGrow={1} verticalAlign="middle">
          <HeaderCell>Статус</HeaderCell>
          <Cell dataKey="status">
            {(operator) => <CommonStatusLabel status={operator.status} />}
          </Cell>
        </Column>

        <Column flexGrow={2} fixed="right" verticalAlign="middle">
          <HeaderCell>Управление</HeaderCell>
          <Cell>
            {(operator) => (
              <EditButton
                as={Link}
                to={generatePath(ROUTE_USERS_MANAGEMENT_EDIT, {
                  type: 'operators',
                  id: operator.id
                })}
                size="xs"
              />
            )}
          </Cell>
        </Column>
      </Table>
      <Pagination
        last
        first
        next
        prev
        ellipsis
        activePage={page}
        pages={pageInfo?.lastPage}
        maxButtons={10}
        onSelect={handlePageSelect}
      ></Pagination>
    </>
  )
}
